import api from '../utils/api';
import { queueRequest } from '../services/syncService';
import { useOfflineStore } from '../stores/offlineStore';

// Search companies by name
export const searchCompanies = async (searchTerm) => {
  const response = await api.get('/companies/search', {
    params: { search: searchTerm }
  });
  return response.data.data.companies;
};

// Get all companies
export const getAllCompanies = async () => {
  const response = await api.get('/companies');
  return response.data.data.companies;
};

// Create a new company
export const createCompany = async (companyData) => {
  const response = await api.post('/companies', companyData);
  return response.data.data.company;
};

/**
 * Create company when online, or queue for sync when offline.
 * Returns the created company (from API) or a stub with _offline: true for UI continuity.
 */
export const createCompanyOrQueueOffline = async (companyData) => {
  const isOffline = (typeof navigator !== 'undefined' && !navigator.onLine) || useOfflineStore.getState().isOnline === false;
  if (isOffline) {
    const { clientId } = await queueRequest('company', 'create', {
      company_name: companyData.company_name,
      address: companyData.address,
      city: companyData.city,
      postcode: companyData.postcode
    }, { endpoint: '/companies', method: 'POST' });
    return {
      id: `offline-${clientId}`,
      company_name: companyData.company_name,
      address: companyData.address,
      city: companyData.city,
      postcode: companyData.postcode,
      _offline: true
    };
  }
  return createCompany(companyData);
};

// Get company by ID
export const getCompanyById = async (id) => {
  const response = await api.get(`/companies/${id}`);
  return response.data.data.company;
};

